import { toQuery } from '@iheartjane/data-access';
import { useQuery, queryOptions } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';

import { janeApiV2 } from '@jane/shared/data-access';

import { storeCategoriesQueryOptions } from './store_categories_legacy';

interface Subtype {
  brand_subtypes: string[];
  subtype: string;
}

export interface StoreCategory {
  kind: string;
  subtypes: Subtype[];
}

const fetchCategories = async (
  retail_org_id?: number
): Promise<StoreCategory[]> => {
  const response = await janeApiV2.get<{ data: StoreCategory[] }>(
    `/business/specials/product_categories${toQuery({ organization_id: retail_org_id })}`
  );
  return response.data;
};

const categoriesQueryOptions = (retail_org_id?: number) => {
  const queryKey: QueryKey = ['product_categories', retail_org_id];
  return queryOptions({
    queryKey,
    queryFn: () => fetchCategories(retail_org_id),
  });
};

export interface UseCategoriesForRulesetsArgs {
  isGlobal: boolean;
  orgId?: number;
  storeId: string;
}

/**
 * Categories available to a ruleset, which come from a different endpoint
 * depending on whether the special is scoped to one store or to a retail org (ie. globally).
 */
export const useCategoriesForRulesets = ({
  isGlobal,
  orgId,
  storeId,
}: UseCategoriesForRulesetsArgs) => {
  return useQuery(
    isGlobal
      ? categoriesQueryOptions(orgId)
      : storeCategoriesQueryOptions(storeId)
  );
};
